// src/app/state/reducers/auth.reducer.ts
import { createReducer, on } from '@ngrx/store';
import * as AuthActions from '../actions/auth.actions';

// src/app/state/models/auth.model.ts
export interface AuthState {
  idToken: string | null;
  refreshToken: string | null;
  customToken: string | null;
  userId: string | null;
  previousUserId: string | null;
}

export const initialState: AuthState = {
  idToken: null,
  refreshToken: null,
  customToken: null,
  userId: null,
  previousUserId: null,
};

export const authReducer = createReducer<AuthState>(
  initialState,
  on(AuthActions.authSuccess, (state, { idToken, refreshToken, userId, customToken }) => ({
    ...state,
    idToken,
    refreshToken,
    customToken,
    previousUserId: state.userId,
    userId,
  })),
  on(AuthActions.logout, (state) => ({
    ...state,
    previousUserId: state.userId,
    idToken: null,
    refreshToken: null,
    userId: null,
  })),
);